import { useTranslation } from "react-i18next";
import { CheckIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ConfirmationModal } from "../ConfirmationModal";
import { Campaign } from "../../models/Campaign";

interface Props {
    info: {
        show: boolean;
        campaign?: Campaign;
    };
    onClose: () => void;
    deleteCampaign: (config: Campaign) => void
}

export const DeleteCampaignModal: React.FC<Props> = ({
    info,
    onClose,
    deleteCampaign
}) => {

    const { t } = useTranslation();

    const onDeleteCampaign = () => {
        deleteCampaign(info.campaign!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_CAMPAIGN")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteCampaign }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_CAMPAIGN_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}